import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import moment from 'moment'
import copy from 'copy-to-clipboard'
import get from 'lodash/get'
import pick from 'lodash/pick'
import startCase from 'lodash/startCase'
import axios from 'axios'

import checkInvitationErrors from '../Actions/checkInvitationErrors'
import { capi, eplApi, projectApi } from '@atheneum/api'

import { formatDate, formatDateToDate, formatDateTime, addQueryParams, CID_STATUS, displayCIDStatus, ComplianceWarningMessage, sendMetric } from '@atheneum/api/dist/lib'

import EPLExpand from './EPLExpand'
import Checkbox from '@components/Checkbox'
import { showDialog, isCancellationError } from '@components/Dialog'
import { Dropdown } from '@components/Autocomplete'
import Button from '@components/Button'
import CalendarIcon from '@components/Icon/Calendar'
import FullProfileIcon from '@components/Icon/FullProfile'
import InvisibleIcon from '@components/Icon/Invisible'
import ShareIcon from '@components/Icon/Share'
import StarIcon from '@components/Icon/Star'
import ReloadIcon from '@components/Icon/Reload2'
import InfoIcon from '@components/Icon/Info'
import VisibleIcon from '@components/Icon/Visible'
import CommentIcon from '@components/Icon/Comment'
import Spinner from '@components/spinner'
import Tooltip from '@components/Tooltip/Tooltip'
import ComplianceButton from '@components/Compliance'
import HFComplianceStatus from '@components/HFComplianceStatus'
import ExpertStatusIcon from '@components/ExpertStatusIcon'
import CopyIcon from '@components/Icon/Copy'
import CancelIcon from '@components/Icon/Cancel'
import CheckIcon from '@components/Icon/Check'
import WarningIcon from '@components/Icon/Warning'
import SherlockReason from '@components/SherlockReason'
import _ from 'lodash'

class EPL extends Component {
  expandRow = e => {
    if (!e.target.id) {
      this.props.eplModel.expand()
    }
  }
  onEPLStatusChange = e => e.stopPropagation()

  openEditEpl = e => {
    e.stopPropagation()
    this.props.eplModel.get().then(() =>
      this.props.modalStore.show({
        type: 'EDIT_EPL',
        props: {
          epl: this.props.eplModel,
          projectStore: this.props.projectStore
        }
      })
    )
  }

  getStatusColor = () => {
    const { EPL_STATUSES } = this.props.staticData.CONST
    const { eplStatusId } = this.props.epl
    const redStatuses = Object.values(
      pick(EPL_STATUSES, ['REJECTED', 'NOT_APPROVED', 'NOT_AVAILABLE'])
    )
    if (redStatuses.includes(eplStatusId)) return 'red'
    if (eplStatusId === EPL_STATUSES.RECRUITMENT) return 'orange'
    return 'green'
  }

  handleReplyStatusSubmit = status => {
    return showDialog({
      title: 'Are you sure you want to change reply status?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes'
    })
      .then(() => {
        this.props.eplModel.changeReplyStatus({
          replyStatusId: status.id,
          updateFilter: true
        })
      })
      .catch(err => {
        if (isCancellationError(err)) return
        const { growlStore } = this.props
        growlStore.showError(err)
      })
  }

  handleExpertSidebar = e => {
    e.stopPropagation()
    this.props.sidebarStore.openSidebar({
      template: 'expert',
      id: this.props.epl.expert.id,
      eplId: this.props.epl.id
    })
  }


  handleCalendarClick = async e => {
    if (e) e.stopPropagation()

    const { eplModel, project, staticData, growlStore, modalStore } = this.props

    await eplModel.get()
    await eplModel.getDetails()
    const { epl } = eplModel

    const { INTERVIEWED } = staticData.CONST.EPL_STATUSES
    const { HEDGE_FUND } = staticData.CONST.ACCOUNT_TYPES
    const parentAccountType = project.office.account.parentAccount.accountTypeId
    const hedgeFundRequired =
      project.office.account.parentAccount.hedgeFundRequired
    const latestConfirmedHfCompliance = epl.expert.hfCompliances.find(
      hfc => hfc.isConfirmed
    )

    if (epl.eplStatusId === INTERVIEWED) {
      growlStore.showError({
        message:
          'You cannot reschedule an interviewed expert. Re-add the expert to the project in case further interviews are needed.'
      })
    } else if (
      parentAccountType === HEDGE_FUND &&
      hedgeFundRequired &&
      !latestConfirmedHfCompliance
    ) {
      growlStore.showError({
        message:
          'You cannot schedule this expert as they have no HF compliance in place.'
      })
    } else {
      modalStore.show({
        type: 'SCHEDULE_CALENDAR_MODAL',
        props: {
          eplModel,
          epl,
          project,
          // projectStore: this.props.projectStore
        }
      })
    }
  }

  handleCalendarIconClick = async e => {
    const { eplModel, growlStore, } = this.props

    const call = eplModel.capiCall
    if (call && call.call_type === 'mcKinsey') {
      growlStore.showError('Action disabled for CAPI calls. Please use the "Schedule" button')
      return
    }

    await this.handleCalendarClick(e)
  }

  generateAnchorLink = e => {
    const { projectStore, epl, growlStore } = this.props

    e.stopPropagation()
    const link = `${window.location.origin}/project/${projectStore.project.id}/experts-pipeline/${epl.id}`
    copy(link)

    return showDialog({
      title: 'URL for the EPL has been copied to your clipboard',
      link,
      type: 'success'
    }).catch(err => {
      if (isCancellationError(err)) return
      growlStore.showError(err)
    })
  }

  triggerCommentSidebar = e => {
    e.stopPropagation()
    const { epl, eplModel, project, sidebarStore } = this.props
    sidebarStore.openSidebar({
      template: 'epl-comments',
      eplModel,
      expert: epl.expert,
      projectStatusId: project.projectStatusId
    })
  }

  updateExpertSubmission = (e) => {
    e && e.stopPropagation()
    this.props.eplModel.execute(async () => {
      const successfulSubmission = await this.onCapiSubmit()
      if (successfulSubmission) {
        this.props.growlStore.showSuccess('Expert successfully updated.')
      }
    })
  }

  onCapiSubmit = async e => {
    const { growlStore, eplStore, epl } = this.props
    const { fee, feeCurrencyId } = epl
    let feeInUSD = undefined
    if (feeCurrencyId && fee) {
      feeInUSD = await eplStore.convertToUSD({
        amount: fee,
        currencyId: feeCurrencyId
      })
    }
    if (e) {
      e.stopPropagation()
      await showDialog({
        title: 'Are you sure you want to submit an update to this expert?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      })
    }

    if (
      !this.props.epl.industryExpertise ||
      (this.props.epl.cv && this.props.epl.cv.experiences.length < 1) ||
      !this.props.eplModel.epl.expert.firstName ||
      !this.props.eplModel.epl.expert.lastName ||
      !this.props.eplModel.epl.expert.address.countryId ||
      !this.props.eplModel.epl.expert.title
    ) {
      growlStore.showError(
        'Expert is missing fields for submission, please check the warnings'
      )
      return false
    }
    try {
      const cv = await axios({
        method: 'get',
        url: `/api/expert/${this.props.epl.expert.id}/positions?eplId=${this.props.epl.id}`,
        headers: {
          authorization: localStorage.getItem('ngStorage-accessToken')
        }
      })

      const hiddenExperienceIds = this.props.epl.hiddenExperiences.map(
        h => h.id
      )

      const data = {
        ...this.props.epl.expert,
        eplId: this.props.epl.id,
        screening: this.props.epl.screening,
        segmentId: this.props.epl.segmentId,
        timezones: this.props.staticData.timezones,
        submittedBy: this.props.epl.submittedBy,
        relevantExperience: this.props.epl.relevantExperience,
        cv: cv.data.filter(e => {
          return !hiddenExperienceIds.includes(e.id)
        }),
        rateInUnits: feeInUSD
      }
      const capiResult = await capi.submitExpert(data)

      if (!capiResult?.expert_id) {
        growlStore.showError(JSON.stringify(capiResult))
        return false
      }

      return true
    } catch (error) {
      if (
        error.response?.data?.message ===
        'Expert with this info has been already created.'
      ) {
        growlStore.showError(`
        Expert has been submitted twice or another network already submitted the expert.
        Expert status will be set to Rejected.
        `)
        return false
      }

      growlStore.showError(
        `${error.response?.data?.message || error.message}`
      )
      return false
    }
  }

  onCapiReject = async e => {
    const { growlStore } = this.props

    if (e) {
      e.stopPropagation()
      await showDialog({
        title: 'Are you sure you want to reject this expert?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      })
    }

    try {
      const data = {
        expertId: this.props.epl.expert.id,
        segmentId: this.props.epl.segmentId
      }

      const capiResult = await capi.rejectExpert(data)

      if (!capiResult?.expert_id) {
        growlStore.showError(JSON.stringify(capiResult))
        return false
      }

      return true
    } catch (error) {
      console.error(error)

      growlStore.showError(
        `${error.response?.data?.message || error.message}`
      )

      return false
    }
  }

  updateEplStatus = async (status, extraFields = {}, dialogOptions = {}) => {
    const { staticData, projectStore, growlStore, modalStore } = this.props
    const { externalComplianceRequired } = projectStore.project.office.account
    const { complianceRequired, complianceTypeId } = projectStore.project
    const { EPL_STATUSES, COMPLIANCE_TYPES } = staticData.CONST
    const { project } = projectStore
    status = _.clone(status)
    if (externalComplianceRequired && complianceRequired) {
      const possibleCurrentStatuses = [
        EPL_STATUSES.RECRUITMENT,
        EPL_STATUSES.NOT_AVAILABLE,
        EPL_STATUSES.NOT_APPROVED,
        EPL_STATUSES.REJECTED,
        EPL_STATUSES.REQUESTED,
        EPL_STATUSES.FOR_MANAGER_APPROVAL
      ]
      const possibleFutureStatuses = [
        EPL_STATUSES.SUBMITTED,
        EPL_STATUSES.REQUESTED,
        EPL_STATUSES.SCHEDULED,
        EPL_STATUSES.INTERVIEWED,
        EPL_STATUSES.NOT_INTERVIEWED
      ]
      if (
        possibleCurrentStatuses.includes(status.eplStatusId) &&
        possibleFutureStatuses.includes(status.eplPossibleStatusId)
      ) {
        if (complianceTypeId === COMPLIANCE_TYPES.CID) {
          // ignored as this is handled on the client interface
        } else if (complianceTypeId === COMPLIANCE_TYPES.EY) {
          if (
            status.eplPossibleStatusId === EPL_STATUSES.SUBMITTED
            && (!(extraFields || {}).externalComplianceStatus)
          ) {
            modalStore.show({
              type: "EY_COMPLIANCE_DIALOG",
              props: {
                modalStore,
                actionAfterSubmit: ({ flagForCompliance, completedAllComplianceQuestions }) => {
                  let externalComplianceStatus = "APPROVED"
                  if (flagForCompliance) {
                    status.eplPossibleStatusId = EPL_STATUSES.COMPLIANCE_AUDIT
                    externalComplianceStatus = "AUDIT_PENDING"
                  }

                  if (!completedAllComplianceQuestions) {
                    status.eplPossibleStatusId = EPL_STATUSES.REJECTED
                    externalComplianceStatus = "INCOMPLETE_SCREENING_QUESTIONS"
                  }

                  setTimeout(() => {
                    this.updateEplStatus(status, {
                      ...(extraFields || {}),
                      externalComplianceStatus
                    }, {
                      ...(dialogOptions || {}),
                      onSuccess: () => {
                        sendMetric('EYCompliance.statusChange', 'EY-compliance-platform', { status: externalComplianceStatus, interface: 'platform' })
                        dialogOptions && dialogOptions.onSuccess && dialogOptions.onSuccess()
                      }
                    })
                  }, 500)
                }
              }
            })
            return
          }
        } else {
          status.eplPossibleStatusId = EPL_STATUSES.COMPLIANCE_AUDIT
        }
      }
    }

    const statusesNotAllowedWithoutCategorySet = [
      EPL_STATUSES.SUBMITTED,
      EPL_STATUSES.COMPLIANCE_AUDIT
    ]
    if (statusesNotAllowedWithoutCategorySet.includes(status.eplPossibleStatusId) && !project.projectCategoryId) {
      modalStore.show({
        type: 'PROJECT_CATEGORY_FORM',
        props: {
          title: 'Set the project category',
          projectStore,
          modalStore,
          actionAfterSubmit: async () => {
            await this.updateEplStatus(status, extraFields)
          }
        }
      })

      return growlStore.showError(`Set the project category in the project details.
        If you don’t have project management permission, please contact your team lead or account manager.`
        , 'Project requires category')
    }

    if (
      status.eplPossibleStatusId ===
      this.props.staticData.CONST.EPL_STATUSES.SCHEDULED
    ) {
      return this.handleCalendarClick()
    }

    if (
      status.eplPossibleStatusId ===
      this.props.staticData.CONST.EPL_STATUSES.NOT_INTERVIEWED
    ) {
      return this.props.modalStore.show({
        type: 'EPL_CANCELLATION_MODAL',
        props: {
          title: 'Set EPL status to Not Interviewed',
          eplModel: this.props.eplModel,
          hideButtons: true,
          forbidCancel: false,
          close: this.props.modalStore.close
        }
      })
    }

    if (
      status.eplPossibleStatusId ===
      this.props.staticData.CONST.EPL_STATUSES.INTERVIEWED
    ) {
      return this.props.modalStore.show({
        type: 'EPL_INTERVIEWED_MODAL',
        props: {
          title: 'Set EPL status to Interviewed',
          eplModel: this.props.eplModel,
          hideButtons: true,
          close: ({ updated = false } = {}) => {
            this.props.modalStore.close()
            if (updated) {
              this.props.feeStore.newFeeCost(this.props.eplModel)
            }
          }
        }
      })
    }

    return showDialog({
      title: 'Are you sure you want to change status?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      ...(dialogOptions || {})
    })
      .then(async () => {
        if (
          status.eplPossibleStatusId ===
          this.props.staticData.CONST.EPL_STATUSES.SUBMITTED &&
          this.props.projectStore.capiDetails &&
          !this.props.projectStore.capiDetails.manual &&
          this.props.projectStore.project.projectCategoryId
        ) {
          if (!await this.onCapiSubmit()) return
        }

        if (
          status.eplPossibleStatusId ===
          this.props.staticData.CONST.EPL_STATUSES.REJECTED &&
          this.props.projectStore.capiDetails &&
          !this.props.projectStore.capiDetails.manual &&
          this.props.projectStore.project.projectCategoryId
        ) {
          if (!await this.onCapiReject()) return
        }

        this.props.eplModel.handleUpdateOnChange({
          updateDetails: false,
          updateFilter: true,
          fields: {
            eplStatusId: status.eplPossibleStatusId,
            ...(extraFields || {})
          }
        })
        dialogOptions && dialogOptions.onSuccess && dialogOptions.onSuccess()

        if (this.props.project.complianceRequired && this.props.staticData.CONST.EPL_STATUSES.SUBMITTED && this.props.projectStore.project.complianceTypeId === COMPLIANCE_TYPES.CID) {
          sendMetric("CIDCompliance.statusChange", 'CID-compliance-platform', { status: 'missing', missing: 1, interface: 'platform' })
        }
      })
      .catch(err => {
        if (isCancellationError(err)) return
        const { growlStore } = this.props
        growlStore.showError(err)
        dialogOptions && dialogOptions.onSuccess && dialogOptions.onError(err)
      })
  }

  changeNameVisibility = (e, hide) => {
    e.stopPropagation()
    this.props.eplModel.changeNameVisibility({
      epl: this.props.epl,
      hide
    })
  }

  createFee(eplModel) {
    this.props.feeStore.newFeeCost(eplModel)
  }

  changeHideFromClient = e => {
    const { epl, staticData } = this.props
    const { EPL_STATUSES } = staticData.CONST
    const { SUBMITTED } = staticData.CONST.EPL_STATUSES

    e.persist()
    e.stopPropagation()

    if (epl.eplStatusId < SUBMITTED) {
      this.updateEplStatus(
        { eplStatusId: epl.eplStatusId, eplPossibleStatusId: EPL_STATUSES.SUBMITTED },
        { hiddenFromClient: false }
      )
    } else {
      this.props.eplModel.handleUpdateOnChange({
        updateDetails: false,
        updateFilter: true,
        fields: {
          hiddenFromClient: !this.props.epl.hiddenFromClient
        }
      })
    }
  }

  changeHideFromClientIcon = e => {
    const { growlStore } = this.props
    const call = this.props.eplModel.capiCall
    if (call && call.call_type === 'mcKinsey') {
      growlStore.showError('Action disabled for CAPI calls. Please use the "Update Expert" button')
      return
    }

    this.changeHideFromClient(e)
  }

  sendRejectionEmailToExpert(eplId, projectId) {
    const { growlStore } = this.props
    return eplApi.sendRejectionEmail(eplId, projectId)
      .then(() => growlStore.showSuccess('Rejection email successfully sent.'))
      .catch(err => growlStore.showError(err))
  }

  renderFeeAction = () => {
    const { epl, staticData, eplModel } = this.props
    if (
      epl.eplStatusId === staticData.CONST.EPL_STATUSES.INTERVIEWED &&
      !epl.feeEntry
    ) {
      return (
        <div className="message">
          <span className="message__error">Hon. & Fee Bundle missing</span>
          <span
            className={`message__action
            ${eplModel.eplValuesBeingUpdated ? 'is-disabled' : ''}`}
            onClick={this.handleCreateFee}>
            Create Bundle
          </span>
        </div>
      )
    }
  }

  renderEmailMissing = expert => {
    const isEmailMissing = !expert.email

    if (isEmailMissing) {
      return (
        <div className="message">
          <span className="message__error">
            Email missing (Cannot invite expert)
          </span>
        </div>
      )
    } else {
      return null
    }
  }

  handleCreateFee = e => {
    e.stopPropagation()
    if (this.props.eplModel.eplValuesBeingUpdated) return
    this.createFee(this.props.eplModel)
  }

  formatCapiStatus = ({ platform_canceled, status, mck_call_id, rejected, in_compliance_review }) => {
    if (status === 'canceled' && platform_canceled) return 'Platform Canceled'
    if (in_compliance_review) return 'Compliance Review'
    if (status === 'completed') return 'Interviewed'
    if (rejected) return 'Expert Rejected'
    if (status === 'scheduled' && !mck_call_id) return 'Platform Scheduled'
    if (status === 'pending') return 'Submitted'
    return startCase(status.replace(/_/g, ' '))
  }

  handleCreateFollowUpEpl = (e) => {
    this.props.eplModel.execute(async () => {
      try {
        e.stopPropagation()
        const { epl, userStore } = this.props
        const call = await capi.createFollowUpEpl(epl.id, userStore.user.id)
        if (!call) {
          this.props.growlStore.showError(JSON.stringify(call))
          return false
        }
        this.props.eplStore.getList(this.props.project.id)
        this.props.eplStore.getFilterOptions(this.props.project.id)
      } catch (e) {
        this.props.growlStore.showError(e)
        console.error(e)
      }
    })
  }

  handleCancelInterview = (e) => {
    e.stopPropagation()
    const { staticData } = this.props
    this.updateEplStatus({
      eplPossibleStatusId: staticData.CONST.EPL_STATUSES.NOT_INTERVIEWED
    })
  }

  renderEplStateCapiActions() {
    const { staticData, eplModel } = this.props
    const actions = []

    const { status, in_compliance_review, call_type } = eplModel.capiCall

    if ((call_type !== 'mcKinsey') &&
      (this.props.epl.eplStatusId === staticData.CONST.EPL_STATUSES.INTERVIEWED || this.props.epl.eplStatusId === staticData.CONST.EPL_STATUSES.NOT_INTERVIEWED)) {
      actions.push(
        <Button white disabled={this.props.eplModel.working} onClick={this.handleCreateFollowUpEpl}>
          <CopyIcon /> Create Follow Up
        </Button>
      )
    } else {
      const capiStatuses = {
        'pending': () => {
          actions.push(
            <Button blue onClick={this.handleCalendarClick}>
              <CalendarIcon />Schedule
            </Button>
          )
          actions.push(
            <Button white disabled={this.props.eplModel.working} onClick={this.updateExpertSubmission}>
              <ReloadIcon /> Update Expert
            </Button>
          )
          actions.push(<Button blue disabled={this.props.eplModel.working} onClick={(e) => {
            this.props.eplModel.execute(async () => {
              e.stopPropagation()
              this.props.eplModel.execute(() => this.updateEplStatus({
                eplPossibleStatusId: staticData.CONST.EPL_STATUSES.NOT_INTERVIEWED
              }))
            })
          }}>
            <CancelIcon /> Cancel
          </Button>
          )
        },
        'expert_suggests_timeslots': () => {
          actions.push(
            <Button blue onClick={this.handleCalendarClick}>
              <CalendarIcon />Schedule
            </Button>
          )
          actions.push(
            <Button white disabled={this.props.eplModel.working} onClick={this.updateExpertSubmission}>
              <ReloadIcon /> Update Expert
            </Button>
          )
          actions.push(<Button blue disabled={this.props.eplModel.working} onClick={(e) => {
            this.props.eplModel.execute(async () => {
              e.stopPropagation()
              this.props.eplModel.execute(() => this.updateEplStatus({
                eplPossibleStatusId: staticData.CONST.EPL_STATUSES.REJECTED
              }))
            })
          }}>
            <CancelIcon /> Reject Expert
          </Button>
          )
        },
        'client_requests_availability': () => {
          actions.push(
            <Button blue onClick={this.handleCalendarClick}>
              <CalendarIcon />Schedule
            </Button>
          )
          actions.push(
            <Button white disabled={this.props.eplModel.working} onClick={this.updateExpertSubmission}>
              <ReloadIcon /> Update Expert
            </Button>
          )
          actions.push(<Button blue disabled={this.props.eplModel.working} onClick={(e) => {
            this.props.eplModel.execute(async () => {
              e.stopPropagation()
              this.props.eplModel.execute(() => this.updateEplStatus({
                eplPossibleStatusId: staticData.CONST.EPL_STATUSES.REJECTED
              }))
            })
          }}>
            <CancelIcon /> Reject Expert
          </Button>
          )
        },
        'client_suggests_timeslots': () => {
          actions.push(
            <Button blue onClick={this.handleCalendarClick}>
              <CalendarIcon />Schedule
            </Button>
          )
          actions.push(
            <Button white disabled={this.props.eplModel.working} onClick={this.updateExpertSubmission}>
              <ReloadIcon /> Update Expert
            </Button>
          )
          actions.push(<Button blue disabled={this.props.eplModel.working} onClick={(e) => {
            this.props.eplModel.execute(async () => {
              e.stopPropagation()
              this.props.eplModel.execute(() => this.updateEplStatus({
                eplPossibleStatusId: staticData.CONST.EPL_STATUSES.REJECTED
              }))
            })
          }}>
            <CancelIcon /> Reject Expert
          </Button>
          )
        },
        'completed': () => {
          actions.push(
            <Button white disabled={this.props.eplModel.working} onClick={this.handleCreateFollowUpEpl}>
              <CopyIcon /> Create Follow Up
            </Button>
          )
          actions.push(
            <Button white disabled={this.props.eplModel.working} onClick={this.handleCancelInterview}>
              <CancelIcon /> Cancel
            </Button>
          )
        },
        'canceled': () => {
          actions.push(
            <Button white disabled={this.props.eplModel.working} onClick={this.handleCreateFollowUpEpl}>
              <CopyIcon /> Create Follow Up
            </Button>
          )
        },
        'scheduled': () => {
          actions.push(
            <Button blue onClick={this.handleCalendarClick}>
              <CalendarIcon />Schedule
            </Button>
          )
          actions.push(
            <Button white disabled={this.props.eplModel.working} onClick={this.updateExpertSubmission}>
              <ReloadIcon /> Update Expert
            </Button>
          )
          actions.push(<Button blue disabled={this.props.eplModel.working} onClick={(e) => {
            this.props.eplModel.execute(async () => {
              e.stopPropagation()
              this.props.eplModel.execute(() => this.updateEplStatus({
                eplPossibleStatusId: staticData.CONST.EPL_STATUSES.NOT_INTERVIEWED
              }))
            })
          }}>
            <CancelIcon /> Cancel
          </Button>
          )
        },
      }

      if (in_compliance_review && status !== 'canceled' && status !== 'completed') {
        actions.push(
          <Button blue onClick={this.handleCalendarClick}>
            <CalendarIcon />Schedule
          </Button>
        )
        actions.push(
          <Button white disabled={this.props.eplModel.working} onClick={this.updateExpertSubmission}>
            <ReloadIcon /> Update Expert
          </Button>
        )
        actions.push(<Button blue disabled={this.props.eplModel.working} onClick={(e) => {
          this.props.eplModel.execute(async () => {
            e.stopPropagation()
            this.props.eplModel.execute(() => this.updateEplStatus({
              eplPossibleStatusId: staticData.CONST.EPL_STATUSES.REJECTED
            }))
          })
        }}>
          <CancelIcon /> Reject Expert
        </Button>
        )
        actions.push(
          <Button white disabled={this.props.eplModel.working} onClick={this.handleCancelInterview}>
            <CancelIcon /> Cancel
          </Button>
        )
      } else {
        if (capiStatuses[status]) {
          capiStatuses[status]()
        }
      }
    }

    if (!actions.length) return null
    return <div key="schedule" className="resubmit-wrapper">
      {actions}
    </div>
  }

  renderEPLStatusDropdown = () => {
    const { EPL_STATUSES, COMPLIANCE_TYPES } = this.props.staticData.CONST

    const status = this.props.eplStore.eplStatuses.find(
      status => status.id === this.props.epl.eplStatusId
    )
    // REVIEW: this is a business rule, for mckinsey automation projects (api integration)
    // status updates after we have submitted the expert to client are driven by the api
    const call = this.props.eplModel.capiCall

    const excludedEplPossibleStatuses = [
      EPL_STATUSES.COMPLIANCE_AUDIT
    ]

    const options = status.eplStatusPossibleChanges.map(status => {
      status.name = status.eplPossibleStatus.name
      return status
    }).reduce((acc, status) => {
      if (excludedEplPossibleStatuses.includes(status.eplPossibleStatusId)) return acc
      acc.push(status)
      return acc
    }, [])

    let capiContent = null

    if (call) {
      if (call.call_type === 'mcKinsey') {
        capiContent = <>{this.renderMckinseyActions()}</>
      } else {
        capiContent = <Dropdown
          blue
          options={options}
          selectedItem={status}
          itemToString={item => item && item.name}
          onChange={status => this.updateEplStatus(status)}
        />
      }

      if ((call.call_type === 'mcKinsey') || (this.props.epl.eplStatusId === EPL_STATUSES.INTERVIEWED || this.props.epl.eplStatusId === EPL_STATUSES.NOT_INTERVIEWED)) {
        capiContent = <>{capiContent}{this.renderEplStateCapiActions()}</>
      }

      return capiContent
    }


    if (
      this.props.project.complianceRequired &&
      this.props.project.complianceTypeId === COMPLIANCE_TYPES.CID &&
      this.props.epl.eplStatusId >= EPL_STATUSES.SUBMITTED
    ) {
      return this.renderCIDActions()
    }

    return (
      <Dropdown
        blue
        options={options}
        selectedItem={status}
        itemToString={item => item && item.name}
        onChange={status => this.updateEplStatus(status)}
      />
    )
  }

  renderCIDActions = () => {
    const status = this.props.eplStore.eplStatuses.find(
      status => status.id === this.props.epl.eplStatusId
    )
    let displayStatus = status.name
    const { EPL_STATUSES } = this.props.staticData.CONST
    if ([EPL_STATUSES.SCHEDULED, EPL_STATUSES.COMPLIANCE_AUDIT, EPL_STATUSES.REJECTED].includes(this.props.epl.eplStatusId)) {

      if (this.props.epl.eplStatusId === EPL_STATUSES.REJECTED && this.props.epl.externalComplianceStatus === CID_STATUS.APPROVED) {
        // edge case for when a cleared expert is later rejected
        // we should show platform status so do nothing
      } else {
        displayStatus = displayCIDStatus(this.props.epl.externalComplianceStatus)
      }
    }
    return (
      <>
        {window.location.search.includes("debug=") && (
          <div style={{ position: "relative" }}>
            <div style={{
              position: "absolute",
              top: -16,
              float: "left",
              fontSize: 12,
              width: "600px"
            }}>
              <span className="epl_status_text">
                Platform Status:{status.name}{"  "}
              </span>
            </div>
          </div>
        )}
        <span style={{ whiteSpace: "nowrap", display: "inline-block" }}>
          <Dropdown
            tooltip="Controlled by CID Compliance"
            disabled
            selectedItem={{ name: displayStatus }}
            itemToString={item => item && item.name}
          />
        </span>
        {this.renderEplStateCIDActions()}
      </>
    )
  }

  renderEplStateCIDActions() {
    const { epl, staticData } = this.props
    const actions = []

    const cancelInterview = (
      <Button white disabled={this.props.eplModel.working} onClick={this.handleCancelInterview}>
        <CancelIcon /> Cancel
      </Button>)

    const scheduleInterview = (
      <Button blue disabled={this.props.eplModel.working} onClick={this.handleCalendarClick}>
        <CalendarIcon />Schedule
      </Button>
    )

    const requestCID = (
      <Button blue disabled={this.props.eplModel.working} onClick={(e) => {
        this.props.eplModel.execute(async () => {
          e.stopPropagation()
          this.props.eplModel.execute(() => this.updateEplStatus({
            eplPossibleStatusId: staticData.CONST.EPL_STATUSES.COMPLIANCE_AUDIT
          }, {
            externalComplianceStatus: CID_STATUS.PENDING
          }, {
            text: ComplianceWarningMessage,
            onSuccess: () => sendMetric("CIDCompliance.statusChange", 'CID-compliance-platform', { status: 'pending', pending: 1, interface: 'platform' }),
            onError: () => sendMetric("CIDCompliance.statusChangeError", 'CID-compliance-platform', { status: 'pending', pending: 1, interface: 'platform' })
          }))
        })
      }}>
        <WarningIcon /> Request CID
      </Button>
    )

    const clearCID = (
      <Button blue disabled={this.props.eplModel.working} onClick={(e) => {
        this.props.eplModel.execute(async () => {
          e.stopPropagation()
          this.props.eplModel.execute(() => this.updateEplStatus({
            eplPossibleStatusId: staticData.CONST.EPL_STATUSES.SUBMITTED
          }, {
            externalComplianceStatus: CID_STATUS.APPROVED
          }, {
            text: ComplianceWarningMessage,
            onSuccess: () => sendMetric("CIDCompliance.statusChange", 'CID-compliance-platform', { status: 'cleared', cleared: 1, interface: 'platform' }),
            onError: () => sendMetric("CIDCompliance.statusChangeError", 'CID-compliance-platform', { status: 'cleared', cleared: 1, interface: 'platform' })
          }))
        })
      }}>
        <CheckIcon /> Clear CID
      </Button>
    )

    const failCID = (
      <Button blue disabled={this.props.eplModel.working} onClick={(e) => {
        this.props.eplModel.execute(async () => {
          e.stopPropagation()
          this.props.eplModel.execute(() => this.updateEplStatus({
            eplPossibleStatusId: staticData.CONST.EPL_STATUSES.REJECTED
          }, {
            externalComplianceStatus: CID_STATUS.REJECTED
          }, {
            text: ComplianceWarningMessage,
            title: "Are you sure you want to mark this expert as Failed CID?",
            onSuccess: () => sendMetric("CIDCompliance.statusChange", 'CID-compliance-platform', { status: 'failed', failed: 1, interface: 'platform' }),
            onError: () => sendMetric("CIDCompliance.statusChangeError", 'CID-compliance-platform', { status: 'failed', failed: 1, interface: 'platform' })
          }))
        })
      }}>
        <CancelIcon /> Fail CID
      </Button>
    )

    const rejectExpert = (
      <Button blue disabled={this.props.eplModel.working} onClick={(e) => {
        this.props.eplModel.execute(async () => {
          e.stopPropagation()
          this.props.eplModel.execute(() => this.updateEplStatus({
            eplPossibleStatusId: staticData.CONST.EPL_STATUSES.REJECTED
          }))
        })
      }}>
        <CancelIcon /> Reject Expert
      </Button>
    )

    const markAsInterviewed = (
      <Button blue disabled={this.props.eplModel.working} onClick={(e) => {
        this.props.eplModel.execute(async () => {
          e.stopPropagation()
          this.props.eplModel.execute(() => this.updateEplStatus({
            eplPossibleStatusId: staticData.CONST.EPL_STATUSES.INTERVIEWED
          }))
        })
      }}>
        <CheckIcon /> Interviewed
      </Button>
    )

    switch (epl.eplStatusId) {
      case staticData.CONST.EPL_STATUSES.COMPLIANCE_AUDIT:
        actions.push(clearCID)
        actions.push(failCID)
        break;
      case staticData.CONST.EPL_STATUSES.REQUESTED:
        actions.push(scheduleInterview)
        actions.push(rejectExpert)
        break;
      case staticData.CONST.EPL_STATUSES.SUBMITTED:
        if (epl.externalComplianceStatus === CID_STATUS.APPROVED) {
          actions.push(scheduleInterview)
          actions.push(failCID)
        } else {
          actions.push(requestCID)
          actions.push(rejectExpert)
        }
        break;
      case staticData.CONST.EPL_STATUSES.NOT_INTERVIEWED:
        if (epl.externalComplianceStatus === CID_STATUS.APPROVED) {
          actions.push(scheduleInterview)
        } else {
          actions.push(requestCID)
        }
        break
      case staticData.CONST.EPL_STATUSES.INTERVIEWED:
        actions.push(cancelInterview)
        break
      case staticData.CONST.EPL_STATUSES.SCHEDULED:
        actions.push(markAsInterviewed)
        actions.push(cancelInterview)
        actions.push(scheduleInterview)

        break;
      case staticData.CONST.EPL_STATUSES.REJECTED:
        actions.push(requestCID)
        actions.push(cancelInterview)
        break;
      default: break
    }
    if (!actions.length) return null
    return <div key="schedule" className="resubmit-wrapper">
      {actions}
    </div>
  }



  renderMckinseyActions = () => {
    const call = this.props.eplModel.capiCall
    const status = this.props.eplStore.eplStatuses.find(
      status => status.id === this.props.epl.eplStatusId
    )
    return (
      <>
        {window.location.search.includes("debug=") && (
          <div style={{ position: "relative" }}>
            <div style={{
              position: "absolute",
              top: -16,
              float: "left",
              fontSize: 12,
              width: "600px"
            }}>
              <span className="epl_status_text">
                Platform Status:{status.name}{"  "}
              </span>
              <span className="epl_status_text" onClick={e => e.stopPropagation()}>
                CAPI[E:{call.expert_id},C:{call.id},W:{call.workstream_id},P:{this.props.projectStore.capiDetails?.id},MCK:{call.mck_call_id}]
              </span>
            </div>
          </div>
        )}
        <span style={{ whiteSpace: "nowrap", display: "inline-block" }}>
          <Dropdown
            tooltip="Controlled by McKinsey"
            disabled
            selectedItem={{ name: this.formatCapiStatus(this.props.eplModel.capiCall) }}
            itemToString={item => item && item.name}
          />
        </span>
      </>
    )
  }

  renderReplyStatusDropdown = () => {
    return (
      <Dropdown
        valueIsId
        itemToString={item => item && item.name}
        options={this.props.staticData.replyStatuses}
        onChange={this.handleReplyStatusSubmit}
        selectedItem={this.props.epl.replyStatusId}
      />
    )
  }

  renderStarIcon = () => {
    const isHiddenFromClient = this.props.epl.hiddenFromClient
    const isStatusHigher =
      this.props.epl.eplStatusId >
      this.props.staticData.CONST.EPL_STATUSES.FOR_MANAGER_APPROVAL
    const starClassName =
      !isHiddenFromClient && isStatusHigher ? ' star-active' : ''

    return (
      <Tooltip tooltip={'Change visibility to client'} placement="left">
        <div
          className={'icons__box' + starClassName}
          onClick={this.changeHideFromClientIcon}>
          <StarIcon />
        </div>
      </Tooltip>
    )
  }

  batchCheck = e => {
    this.props.batchCheck(this.props.epl)
  }

  renderFieldsMissing = () => {
    const { expert } = this.props.eplModel.epl

    return (
      <>
        {!expert.address.countryId && (
          <div className="message">
            <span className="message__error">
              Country is missing on the address (Cannot submit the expert)
            </span>
          </div>
        )}
        {!expert.title && (
          <div className="message">
            <span className="message__error">
              Title is missing (Cannot submit the expert)
            </span>
          </div>
        )}
        {!expert.firstName && (
          <div className="message">
            <span className="message__error">
              First Name is missing (Cannot submit the expert)
            </span>
          </div>
        )}
        {!expert.lastName && (
          <div className="message">
            <span className="message__error">
              Last Name is missing (Cannot submit the expert)
            </span>
          </div>
        )}
        {this.props.epl.cv && this.props.epl.cv.experiences.length < 1 && (
          <div className="message">
            <span className="message__error">
              Experiences are missing (Cannot submit the expert)
            </span>
          </div>
        )}
        {!this.props.epl.industryExpertise && (
          <div className="message">
            <span className="message__error">
              Industry Experience is missing (Cannot submit the expert)
            </span>
          </div>
        )}
      </>
    )
  }

  renderScreeningFieldMissing = (screening, eplStatusId) => {
    const eplStatuses = this.props.staticData.CONST.EPL_STATUSES
    const eplStatus = Object.keys(eplStatuses).find(
      key => eplStatuses[key] === eplStatusId
    )
    const correctStatus = [
      'SUBMITTED',
      'SCHEDULED',
      'INTERVIEWED',
      'NOT_INTERVIEWED'
    ].includes(eplStatus)

    return !screening && correctStatus ? (
      <div className="message">
        <span className="message__error">
          Warning: Screening field is empty
        </span>
      </div>
    ) : null
  }

  checkExperiences = experiences => {
    let check = true
    experiences.forEach(e => {
      const start = new Date(e.startDate)
      const end = e.endDate === null ? new Date() : new Date(e.endDate)

      if (end.getTime() < start.getTime()) {
        check = e
      }
    })

    return check
  }

  renderExperienceWarnings = e => {
    return e ? (
      <div className="message">
        <span className="message__error">
          {`${e.company.name} - ${e.position.name} has start date larger than end date.`}
          <br />
          {`Start Date: ${moment(e.startDate).format(
            'DD.MM.YYYY'
          )} End Date: ${moment(
            e.endDate === null ? new Date() : e.endDate
          ).format('DD.MM.YYYY')}`}
        </span>
      </div>
    ) : null
  }

  renderWarnings = () => {
    const { staticData, eplModel, project } = this.props
    const expert = {
      ...eplModel.epl.expert.expert,
      email: eplModel.epl.expert.email,
      userId: eplModel.epl.expert.id,
      eplId: eplModel.epl.id
    }
    const { HEDGE_FUND } = staticData.CONST.ACCOUNT_TYPES

    let experienceCheck = false
    if (this.props.epl.cv) {
      experienceCheck = this.checkExperiences(this.props.epl.cv.experiences)
    } else if (this.props.epl.expert.cv) {
      experienceCheck = this.checkExperiences(this.props.epl.expert.cv.experiences)
    }

    return (
      <div className="m-t-sm font-small">
        {(!this.props.epl.industryExpertise ||
          (this.props.epl.cv && this.props.epl.cv.experiences.length < 1) ||
          !this.props.eplModel.epl.expert.firstName ||
          !this.props.eplModel.epl.expert.lastName ||
          !this.props.eplModel.epl.expert.address.countryId ||
          !this.props.eplModel.epl.expert.title) &&
          this.props.projectStore.capiDetails
          ? this.renderFieldsMissing()
          : null}
        {experienceCheck === true
          ? null
          : this.renderExperienceWarnings(experienceCheck)}
        {this.renderEmailMissing(expert)}
        {this.renderScreeningFieldMissing(
          this.props.epl.screening,
          this.props.epl.eplStatusId
        )}
        {this.renderFeeAction()}
        <ComplianceButton
          className="m-t-sm"
          expert={expert}
          callback={this.props.eplModel.get}
          referrer={`project/${eplModel.epl.projectId}/experts-pipeline/${eplModel.epl.id}`}
        />
        {project.office.account.parentAccount.accountTypeId === HEDGE_FUND &&
          project.office.account.parentAccount.hedgeFundRequired && (
            <HFComplianceStatus
              expert={expert}
              hfCompliances={eplModel.epl.expert.hfCompliances}
              callback={this.props.eplModel.get}
            />
          )}
        {this.renderSendResendRejectionEmail(eplModel)}
      </div>
    )
  }

  renderSendResendRejectionEmail(eplModel) {
    const epl = eplModel.epl
    if (epl.enableRejectionEmailSend) {
      return (
        <div className="m-t-sm">
          <span
            className="link inline"
            onClick={async e => {
              e.stopPropagation()
              await this.sendRejectionEmailToExpert(epl.id, epl.projectId)
              await eplModel.get()
            }}>
            Send rejection email
          </span>
        </div>
      )
    }

    if (epl.enableRejectionEmailResend) {
      return (
        <div className="m-t-sm">
          <span className="code-label">Rejection email sent</span>
          <span
            className="link inline m-l-sm"
            onClick={e => {
              e.stopPropagation()
              this.sendRejectionEmailToExpert(epl.id, epl.projectId)
            }}>
            Click to resend
          </span>
        </div>
      )
    }
  }

  renderScheduledDate = () => {
    const { epl } = this.props

    const availabilityWithSchedule = epl.expertAvailabilityToEpls
      .filter(a => a)
      .find(a => {
        return a.schedule && !a.schedule.canceled
      })

    const schedule = availabilityWithSchedule
      ? availabilityWithSchedule.schedule
      : undefined
    if (!schedule || !schedule.startTime) return null

    return (
      <div className="schedule-wrapper" onClick={e => e.stopPropagation()}>
        <span className="schedule-wrapper__date">
          {moment(schedule.startTime).format('MMM DD')}
        </span>
        <div className="schedule-wrapper__separator" />
        <span className="schedule-wrapper__time">
          {moment(schedule.startTime).format('HH:mm')}
        </span>
      </div>
    )
  }

  renderDate = date => {
    return (
      <div className="schedule-wrapper" onClick={e => e.stopPropagation()}>
        <span className="schedule-wrapper__date">{formatDate(date)}</span>
      </div>
    )
  }

  renderInterviewCount = () => {
    const { eplModel, projectStore } = this.props
    const { interviewCount } = eplModel.epl
    const { parentAccountCode } =
      projectStore.project.office.account.parentAccount

    const count = interviewCount.interviewCount || 0
    return (
      <div className="gray font-small">
        {count} interview(s) with {parentAccountCode}
      </div>
    )
  }

  renderExperience = epl => {
    const experience = get(epl, 'relevantExperience.experience', null)

    if (!experience) return null

    const position = get(experience, 'position.name')
    const companyName = get(experience, 'company.name')
    const experienceDate = formatDateToDate(
      experience.startDate,
      experience.endDate,
      'MMM YYYY'
    )
    const companyAndExperience = `${companyName} (${experienceDate})`
    const location = experience.location

    return (
      <div>
        {position && <p>{position}</p>}
        {companyAndExperience && <p>{companyAndExperience}</p>}
        {location && <p>{location}</p>}
      </div>
    )
  }

  renderEplEmailStatus = (epl, eplEmailType) => {
    try {
      const eplEmails = epl.emails
        .filter(e => e.type === eplEmailType)
        .sort((e1, e2) => new Date(e2.created_at) - new Date(e1.created_at))
      if (!eplEmails.length) {
        return eplEmailType === 'expert_follow_up'
          ? 'Follow-up'
          : 'Invitation -'
      }

      const templateNameMap = {
        expert_invite: 'Invitation',
        cold_expert_invite: 'Invitation',
        expert_follow_up_1: 'First follow up',
        expert_follow_up_2: 'Second follow up',
        expert_follow_up_3: 'Third follow up'
      }

      const latestEplEmail = eplEmails[0]
      // Remove the first 5 characters because that's language designator (e.g. '[EN] expert_invite')
      const emailName = templateNameMap[latestEplEmail.templateName.slice(5)]

      const latestEplEmailRecipientEvent =
        latestEplEmail.recipients[0].events[0]

      let action
      switch (
      latestEplEmailRecipientEvent &&
      latestEplEmailRecipientEvent.event
      ) {
        case 'click':
          action = 'clicked'
          break
        case 'open':
          action = 'opened'
          break
        case 'send':
          action = 'delivered'
          break
        default:
          action = 'sent'
          break
      }
      const timestamp =
        (latestEplEmailRecipientEvent &&
          latestEplEmailRecipientEvent.timestamp) ||
        latestEplEmail.created_at
      return `${emailName} ${action} on ${formatDateTime(timestamp, false)}`
    } catch (err) {
      console.error(err)
      return 'Could not get email status'
    }
  }

  renderInviteLink = isDoNotContact => {
    const { segmentStore, staticData, eplModel, match, epl } = this.props

    return (
      <div
        disabled={isDoNotContact}
        className="link inline m-l-sm"
        onClick={e => {
          e.stopPropagation()
          if (isDoNotContact) return
          const { eligible, errors } = checkInvitationErrors({
            staticData,
            segments: segmentStore.segments,
            selectedEpls: [eplModel]
          })

          if (!eligible) {
            return showDialog({
              title: 'Cannot invite experts',
              html: `<div>${errors.join('<br /><br />')}</div>`,
              type: 'error'
            }).catch(err => isCancellationError(err))
          }

          const expertIds = [eplModel.epl.expert.id]
          const projectId = this.props.project.id
          const loadTemplateUrl = addQueryParams(
            '/api/expert-project-link/expert-invite-template',
            { expertIds, segmentId: eplModel.epl.segmentId }
          )
          const segment = segmentStore.segments.find(
            s => s.id === eplModel.epl.segmentId
          )
          const senderIds = segment.employees.map(e => e.id)

          return this.props.modalStore.show({
            type: 'EMAIL_TEMPLATE_SEND',
            props: {
              group: 'expert_invite',
              loadTemplateUrl,
              onSend: templateData =>
                eplApi.bulkInvite({ eplIds: [eplModel.id], templateData }),
              onAfterSend: () => {
                this.props.modalStore.close()

                return showDialog({
                  title: 'Expert has been invited to the project',
                  type: 'success'
                }).then(() => {
                  if (match && match.params.eplId) {
                    this.props.eplStore.getSingleEPL(projectId, epl.id)
                  } else {
                    this.props.eplStore.getList(projectId)
                    this.props.eplStore.getFilterOptions(projectId)
                  }
                })
              },
              senderIds
            }
          })
        }}>
        Send invite
      </div>
    )
  }

  renderAtheneumGuestLink = (epl, EPL_STATUS_SCHEDULED) => {
    const { atheneumGuestLink } = epl

    if (
      epl.eplStatusId !== EPL_STATUS_SCHEDULED
      || !atheneumGuestLink
    ) {
      return
    }

    return (
      <div className="link-row gray font-small m-t-sm">
        <div>Join the meeting as </div>
        <div>
          <div className="link inline m-l-sm">
            <a href={atheneumGuestLink} target="_blank" rel="noreferrer">
              "Atheneum Guest"
            </a>
          </div>
        </div>
      </div>
    )
  }

  renderFollowUpLink = ({ isDisabled }) => {
    const { segmentStore, staticData, eplModel, project, epl, match } =
      this.props
    const isInvited = eplModel.epl.emails.some(e => e.type === 'expert_invite')
    if (!isInvited) return null
    return (
      <div
        disabled={isDisabled}
        className="link inline m-l-sm"
        onClick={e => {
          e.stopPropagation()
          if (isDisabled) return
          const { eligible, errors } = checkInvitationErrors({
            staticData,
            segments: segmentStore.segments,
            selectedEpls: [eplModel]
          })

          if (!eligible) {
            return showDialog({
              title: 'Cannot email experts',
              html: `<div>${errors.join('<br /><br />')}</div>`,
              type: 'error'
            }).catch(err => isCancellationError(err))
          }

          const expertIds = [eplModel.epl.expert.id]
          const loadTemplateUrl = addQueryParams(
            '/api/expert-project-link/expert-follow-up-template',
            { expertIds }
          )
          const segment = segmentStore.segments.find(
            s => s.id === eplModel.epl.segmentId
          )
          const senderIds = segment.employees.map(e => e.id)

          return this.props.modalStore.show({
            type: 'EMAIL_TEMPLATE_SEND',
            props: {
              group: 'expert_follow_up',
              loadTemplateUrl,
              onSend: templateData =>
                projectApi.emailExperts({
                  eplIds: [eplModel.id],
                  templateData
                }),
              onAfterSend: () => {
                this.props.modalStore.close()

                return showDialog({
                  title: 'Email sent to expert',
                  type: 'success'
                }).then(() => {
                  if (match && match.params.eplId) {
                    this.props.eplStore.getSingleEPL(project.id, epl.id)
                  } else {
                    this.props.eplStore.getList(project.id)
                    this.props.eplStore.getFilterOptions(project.id)
                  }
                })
              },
              senderIds
            }
          })
        }}>
        Send follow up
      </div>
    )
  }

  renderExpertDeclineReason = epl => {
    const { staticData } = this.props
    const { THE_BEST_PERSON_TO_TALK_TO_IS, OTHER } =
      staticData.CONST.EPL_REPLY_STATUS_COMMENTS

    const reasonId = epl.eplRejectionReason[0].eplReplyStatusCommentId
    const showTooltip =
      reasonId === OTHER || reasonId === THE_BEST_PERSON_TO_TALK_TO_IS

    return (
      <div className="link-row gray font-small m-t-sm">
        Expert declined - {staticData.names.eplReplyStatusComments[reasonId]}
        {showTooltip && <Tooltip tooltip="Check comments on EPL" />}
      </div>
    )
  }

  componentDidMount() {
    this.props.eplModel.component = ReactDOM.findDOMNode(this)
  }

  render() {
    const { epl, project, eplModel, staticData } = this.props
    if (!epl) return null

    const rowClassName = ' single--' + this.getStatusColor()

    let calendarClassName = ''
    const EPL_STATUSES = staticData.CONST.EPL_STATUSES
    if (
      project.clientToProjectAvailabilities.length > 0 &&
      epl.eplStatusId === EPL_STATUSES.REQUESTED
    ) {
      calendarClassName = ' epl-calendar-active-client-available'
    } else if (epl.expertAvailabilityToEpls.length > 0) {
      calendarClassName = ' epl-calendar-active'
    }

    const expertInvitesExist = epl.emails.some(e => e.type === 'expert_invite')

    const style = { minHeight: `${eplModel.height}px` }

    const { DO_NOT_CONTACT } = staticData.CONST.EXPERT_STATUSES
    const { NOT_INTERESTED } = staticData.CONST.REPLY_STATUSES
    const isDoNotContact =
      eplModel.epl.expert.expert.expertStatusId === DO_NOT_CONTACT
    const isNotInterested = eplModel.epl.replyStatusId === NOT_INTERESTED

    const seenCommentsCount = epl.expertProjectLinkNotes.filter(
      n => n && n.seen && n.seen.length
    ).length
    const unseenCommentsExist = epl.expertProjectLinkNotes &&
      epl.expertProjectLinkNotes.length &&
      epl.expertProjectLinkNotes.length > seenCommentsCount

    let commentsClassName = ''
    if (unseenCommentsExist) {
      commentsClassName = ' comments-unread'
    }

    let disabledTooltipMessage = 'Expert is not interested'
    if (isDoNotContact) {
      disabledTooltipMessage = 'Expert in Do not contact status'
    }

    let shouldShowRejectionTooltip = false;
    const rejectionReasonExists =
      epl.eplStatusId === staticData.CONST.EPL_STATUSES.REJECTED &&
      epl.eplRejectionReason &&
      epl.eplRejectionReason.length > 0
    if (rejectionReasonExists) {
      // Show rejection reason if there's a reason, not just for Mckinsey automation project
      shouldShowRejectionTooltip = true;
    }

    let shouldShowAcceptanceTooltip = false
    const acceptanceReasonExists =
      epl.eplStatusId === staticData.CONST.EPL_STATUSES.SUBMITTED &&
      epl.eplAcceptanceReason &&
      epl.eplAcceptanceReason.length > 0
    if (acceptanceReasonExists) {
      const acceptedByAuditor = epl.eplAcceptanceReason
        ? epl.eplAcceptanceReason.find(r =>
          r.additionalComment?.includes(
            'Expert has been accepted by Compliance auditor'
          )
        )
        : null

      shouldShowAcceptanceTooltip =
        (this.props.projectStore.capiDetails &&
          !this.props.projectStore.capiDetails.manual) ||
        acceptedByAuditor
    }

    return (
      <div className={'single' + rowClassName} style={style}>
        {!eplModel.isVisible ? (
          <div>EPL {epl.expert.fullName}</div>
        ) : (
          <div>
            <Checkbox
              className="single__checkbox"
              onChange={eplModel.batchCheck}
              value={eplModel.batchChecked}
            />

            <div className="single__content">
              <div
                className="single__content__thumb"
                onClick={this.expandRow}
                data-cy={epl.id}>
                <div className="info">
                  <div className="info__text">
                    <div className="info__text__inline">
                      <div>
                        <span className="row--link" onClick={this.openEditEpl}>
                          <strong>
                            {epl.eplNumber ? epl.eplNumber + ' - ' : ''}
                            {epl.expert.title} {epl.expert.fullName}
                          </strong>
                        </span>
                        <ExpertStatusIcon
                          expertStatusId={epl.expert.expert.expertStatusId}
                          eplView
                        />
                        {epl.sherlock && (
                          <SherlockReason sherlock={epl.sherlock} iconOnly />
                        )}
                        {' ' +
                          staticData.getDataFromArray(
                            epl.expert.address.countryId,
                            'countries'
                          )}
                        <span className="code-label">
                          {' '}
                          {epl.expert.expert.expertCode}
                        </span>
                      </div>
                      <div className="tooltip-wrapper">
                        {epl.nameDisclosed ? (
                          <Tooltip
                            tooltip={"Hide Expert's name on Client Interface"}
                            inline>
                            <div
                              className="inline"
                              onClick={e => this.changeNameVisibility(e, true)}>
                              <VisibleIcon />
                            </div>
                          </Tooltip>
                        ) : (
                          <Tooltip
                            tooltip={"Show Expert's name on Client Interface"}
                            inline>
                            <div
                              className="inline"
                              onClick={e =>
                                this.changeNameVisibility(e, false)
                              }>
                              <InvisibleIcon />
                            </div>
                          </Tooltip>
                        )}
                      </div>
                      {eplModel.loading ? <Spinner inline /> : null}
                    </div>
                    {this.renderExperience(epl)}
                    {this.renderWarnings()}
                    <div className="m-t-sm">{this.renderInterviewCount()}</div>
                  </div>
                </div>

                <div className="actions hero-actions">
                  <div className="actions__single actions__single--filledDropdown">
                    <span className="actions__single__label">EPL status</span>
                    <div
                      className="actions__single__value"
                      data-cy="epl-status-dropdown"
                      data-cy-epl={epl.id}>
                      {this.renderEPLStatusDropdown()}
                      {epl.eplStatusId ===
                        staticData.CONST.EPL_STATUSES.SCHEDULED
                        ? this.renderScheduledDate()
                        : null}
                      {shouldShowRejectionTooltip ? (
                        <div className="rejection-wrapper">
                          {/* Filter out empty comments */}
                          <Tooltip
                            tooltip={epl.eplRejectionReason
                              .filter(r => r.additionalComment !== '')
                              .map(r => (
                                <>
                                  {r.additionalComment}
                                  <br />
                                </>
                              ))}
                            placement="top">
                            <InfoIcon />
                          </Tooltip>
                        </div>
                      ) : null}
                      {shouldShowAcceptanceTooltip ? (
                        <div className="acceptance-wrapper">
                          <Tooltip
                            tooltip={epl.eplAcceptanceReason.map(r => (
                              <>
                                {r.additionalComment}
                                <br />
                              </>
                            ))}
                            placement="top">
                            <InfoIcon />
                          </Tooltip>
                        </div>
                      ) : null}
                      {epl.eplStatusId ===
                        staticData.CONST.EPL_STATUSES.INTERVIEWED
                        ? this.renderDate(epl.dateInterviewed)
                        : null}
                      {epl.eplStatusId ===
                        staticData.CONST.EPL_STATUSES.NOT_INTERVIEWED
                        ? this.renderDate(epl.dateInterviewCanceled)
                        : null}
                    </div>
                  </div>

                  <div className="actions__single">
                    <span className="actions__single__label">Reply status</span>
                    <div
                      className="actions__single__value"
                      data-cy="reply-status-dropdown">
                      {' '}
                      {this.renderReplyStatusDropdown()}{' '}
                    </div>
                  </div>

                  <div className="invitation-followup compliance-wrapper m-t-sm">
                    <div className="link-row gray font-small">
                      <div>
                        {this.renderEplEmailStatus(epl, 'expert_invite')}{' '}
                      </div>
                      <Tooltip
                        placement="bottom"
                        tooltip={disabledTooltipMessage}
                        disabled={!isDoNotContact}>
                        <div>{this.renderInviteLink(isDoNotContact)}</div>
                      </Tooltip>
                    </div>
                    {expertInvitesExist ? (
                      <div className="link-row gray font-small m-t-sm">
                        <div>
                          {this.renderEplEmailStatus(epl, 'expert_follow_up')}{' '}
                        </div>
                        <div>
                          {expertInvitesExist ? (
                            <Tooltip
                              placement="bottom"
                              tooltip={disabledTooltipMessage}
                              disabled={!(isDoNotContact || isNotInterested)}>
                              {this.renderFollowUpLink({
                                isDisabled: isDoNotContact || isNotInterested
                              })}
                            </Tooltip>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                    {isNotInterested &&
                      epl.eplRejectionReason &&
                      epl.eplRejectionReason.length
                      ? this.renderExpertDeclineReason(epl)
                      : null}
                    {this.renderAtheneumGuestLink(
                      epl,
                      staticData.CONST.EPL_STATUSES.SCHEDULED
                    )}
                  </div>
                </div>

                <div className={'icons' + calendarClassName}>
                  {this.renderStarIcon()}
                  <Tooltip tooltip={'Open scheduling tool'} placement="left">
                    <div
                      data-cy="open-scheduling-tool-btn"
                      data-cy-epl={epl.id}
                      className="icons__box"
                      onClick={this.handleCalendarIconClick}>
                      <CalendarIcon />
                    </div>
                  </Tooltip>
                  <Tooltip
                    tooltip={'Copy EPL link to clipboard'}
                    placement="left">
                    <div
                      className="icons__box"
                      onClick={this.generateAnchorLink}>
                      <ShareIcon />
                    </div>
                  </Tooltip>
                  <Tooltip
                    tooltip={'Open expert profile in sidebar'}
                    placement="left">
                    <div
                      className="icons__box"
                      onClick={this.handleExpertSidebar}>
                      <FullProfileIcon />
                    </div>
                  </Tooltip>
                  <Tooltip
                    tooltip="Open EPL comments in sidebar"
                    placement="left">
                    <div
                      className={'icons__box' + commentsClassName}
                      onClick={this.triggerCommentSidebar}>
                      <CommentIcon />
                    </div>
                  </Tooltip>
                </div>
              </div>
              <EPLExpand
                epl={epl}
                eplModel={eplModel}
                projectStore={this.props.projectStore}
              />
            </div>
          </div>
        )}
      </div>
    )
  }
}

EPL.propTypes = {
  staticData: PropTypes.object,
  eplStore: PropTypes.object,
  epl: PropTypes.object,
  eplModel: PropTypes.object,
  project: PropTypes.object,
  projectStore: PropTypes.object,
  sidebarStore: PropTypes.object,
  feeStore: PropTypes.object,
  modalStore: PropTypes.object,
  batchCheck: PropTypes.func,
  growlStore: PropTypes.object,
  segmentStore: PropTypes.object,
  match: PropTypes.object
}

export default inject(
  'modalStore',
  'feeStore',
  'staticData',
  'projectStore',
  'sidebarStore',
  'growlStore',
  'segmentStore',
  'userStore'
)(observer(EPL))
